module.exports = __webpack_public_path__ + "static/media/cover.7e6ad94a.png";